<!-- @format -->

<project-history-tag>

	<div class="container_contents">
		
		<div class="container_breadcrumb">
			<ul class="breadcrumb">
				<li class="breadcrumb-item"><span class="heading-01 heading_orders">受注履歴・請求関連</span></li>
				<li class="breadcrumb-item">受注履歴と確定報酬一覧</li>
			</ul>
		</div><!--/.container_breadcrumb-->


		
		<div class="contents">

			<div class="tab-menu margin-spacing-4_bottom">
				<ul class="tab-menu-list">
					<li class="tab-menu-list-item is-active">
						<a href="/project/history">受注履歴と確定報酬一覧</a>
					</li>
					<li class="tab-menu-list-item">
						<a href="/project/paid-summary">支払調書</a>
					</li>
				</ul>
			</div>

			<section class="contents_area">
				
				<p class="text margin-spacing-4_bottom">現在までの案件の受注履歴と、確定した報酬の一覧を表示しています。</p>
				
        <div is="current_reward"></div>
				
        <!--
				<div class="tab-menu margin-spacing-4_bottom margin-spacing-4_top">
          <ul class="tab-menu-list">
            <li each="{ tab in Tabs }" class="tab-menu-list-item { tab.name == state.tabName ? 'is-active' :'' }">
              <a class="js-tab" onclick="{ e => onTab(e, tab.name)}"> { tab.label }</a>
            </li>
          </ul>
        </div>
        -->
        <div class="tab-menu margin-spacing-4_bottom margin-spacing-4_top">
        </div>
              
        <div class="tab_contents { state.tabName=='orders' ? 'active' : '' }" is="orders"></div>
        <!-- <div class="tab_contents { state.tabName=='rewards' ? 'active' : '' }" is="rewards"></div> -->
        
			</section><!--/.contents_area-->
			
		</div><!--/.contents-->
	</div><!--/.container_contents-->
  <script>
    import di from "dependency-injection";
    import orders from "@tags/parts/project/history/orders.riot";
    //import rewards from "@tags/parts/project/history/rewards.riot";
    import current_reward from "@tags/parts/project/history/current-reward.riot";

    export default {
      components: { orders, /*rewards ,*/ current_reward },
      Tabs: [
        { name: "orders", label: "受注履歴" },
        //{ name: "rewards", label: "報酬一覧" },
      ],
      state: {
        tabName: "orders",
      },
      onMounted(state, props) {
        window.$(".accordion_body").css("display", "none");
      },
      onTab(e, tabName) {
        this.update({ tabName });
      },
    };
  </script>
</project-history-tag>
